import VariantModel from 'coreClasses/product/VariantModel';
import {IEventData} from 'coreClasses/events/IEvents';
import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';

import {EAnalyticsEventType} from 'brandClasses/analytics/EAnalyticsEvent';

import ProductItemEvent from './common/ProductItemEvent';

/**
 * Represents ViewItemEvent
 */
export default class ViewItemEvent implements IAnalyticsEvent {
	public event: string;
	public event_trigger: string;
	public ecommerce: any;

	/**
	 * @constructor
	 * @param {IEventData} data - data
	 */
	constructor(data: IEventData) {
		const product: VariantModel = data?.productData?.product;
		const productCategoriesIds: string[] = data?.productData?.productCategoriesIds;
		const eventSourceCategoryId = data?.eventSourceCategoryId;
		const eventSourceCategoryName = data?.eventSourceCategoryName;
		const productItem = new ProductItemEvent({
			product,
			productCategoriesIds,
			eventSourceCategoryId,
			eventSourceCategoryName
		});

		delete productItem.item_list_id;

		this.event = EAnalyticsEventType.VIEW_ITEM;
		this.event_trigger = 'ecomm';
		this.ecommerce = {
			currency: product.getPriceCurrency(),
			value: Math.floor(product.getPriceModel().getMinPrice().value),
			items: [{...productItem}],
		};
	}
}
